import React, { useEffect, useState } from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import { useParams } from "react-router-dom";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { CircularProgress, LinearProgress } from "@mui/material";
import PanelDetails from "../../../UI/Panels/View";

const ViewPanel = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    smmpanel_name: "",
    smmpanel_loginuser: "",
    smmpanel_login_password: "",
    smmpanel_api_key: "",
    smmpanel_api_url: "",
    smmpanel_ticket_numper: "",
    smmpanel_date_of_ticket: null,
    smmpanel_url: "",
    description: "",
    smmpanel_email: "",
    smmpanel_instagram: "",
    smmpanel_skype: "",
    smmpanel_telegram: "",
    smmpanel_fb: "",
    smmpanel_twitter: "",
    smmpanel_whatsapp: "",
    smmpanel_tel1: "",
    reading_status: "",
    customLogo: "",
    logo: null,
    smmpanel_notice: "",
    url_service: "",
    trust: 0,
    expired: "",
    smmpanel_domain_registered: "",
    smmpanel_domain_expires: "",
    country_name: "",
    screenShot: null,
    payment_method: [],
    count_review: 0,
    reviews: [],
    rate: {},
    services: [],
    pagination: {},
  });

  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.Panels.GetOne}${id}`,
      });

      if (response) {
        setFormData({
          smmpanel_name: response?.data?.panel_details?.smmpanel_name || "",
          smmpanel_loginuser:
            response?.data?.panel_details?.smmpanel_loginuser || "",
          smmpanel_login_password:
            response?.data?.panel_details?.smmpanel_login_password || "",
          smmpanel_api_key:
            response?.data?.panel_details?.smmpanel_api_key || "",
          smmpanel_api_url:
            response?.data?.panel_details?.smmpanel_api_url || "",
          smmpanel_ticket_numper:
            response?.data?.panel_details?.smmpanel_ticket_numper || "",
          smmpanel_date_of_ticket:
            response?.data?.panel_details?.smmpanel_date_of_ticket || null,
          smmpanel_url: response?.data?.panel_details?.smmpanel_url || "",
          description: response?.data?.panel_details?.description || "",
          smmpanel_email: response?.data?.panel_details?.smmpanel_email || "",
          smmpanel_instagram:
            response?.data?.panel_details?.smmpanel_instagram || "",
          smmpanel_skype: response?.data?.panel_details?.smmpanel_skype || "",
          smmpanel_telegram:
            response?.data?.panel_details?.smmpanel_telegram || "",
          smmpanel_fb: response?.data?.panel_details?.smmpanel_fb || "",
          smmpanel_twitter:
            response?.data?.panel_details?.smmpanel_twitter || "",
          smmpanel_whatsapp:
            response?.data?.panel_details?.smmpanel_whatsapp || "",
          smmpanel_tel1: response?.data?.panel_details?.smmpanel_tel1 || "",
          reading_status: response?.data?.panel_details?.reading_status || "",
          reading_type: response?.data?.panel_details?.reading_type || "",
          customLogo: response?.data?.panel_details?.customLogo || "",
          logo: response?.data?.panel_details?.logo || null,
          smmpanel_notice: response?.data?.panel_details?.smmpanel_notice || "",
          url_service: response?.data?.panel_details?.url_service || "",
          trust: response?.data?.panel_details?.trust || 0,
          expired: response?.data?.panel_details?.expired || "",
          smmpanel_domain_registered:
            response?.data?.panel_details?.smmpanel_domain_registered || "",
          smmpanel_domain_expires:
            response?.data?.panel_details?.smmpanel_domain_expires || "",
          country_name: response?.data?.panel_details?.country_name || "",
          screenShot: response?.data?.panel_details?.screenShot || "",
          payment_method:
            response?.data?.payment_method?.length > 0
              ? response?.data?.payment_method?.map((method) => method.type)
              : [],
          count_review: response?.data?.count_review,
          reviews: response?.data?.reviews,
          rate: response?.data?.rate,
          services: response?.data?.services,
          pagination: response?.data?.pagination,
        });
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <PanelHead
        title={
          isLoading ? (
            <div className="flex items-center gap-4">
              Panel details <CircularProgress size={24} />
            </div>
          ) : (
            <div className="flex items-center justify-between w-full gap-4">
              <div>Panel details: {formData?.smmpanel_name}</div>
            </div>
          )
        }
      />
      <PanelBody
        content={
          isLoading ? <LinearProgress /> : <PanelDetails data={formData} />
        }
      />
    </div>
  );
};

export default React.memo(ViewPanel);
